import Importer from './Importer';
import Dot from '../track/Dot';
import Dots from '../track/Dots';
import Event from '../track/Event';

export default class ImporterNMEA extends Importer {
  constructor(fileName, fileData) {
    super(fileName, fileData);

    this.ROW_SEPARATOR = '$';
    this.ROW_HEADER_DOT = 'GPRMC';
    this.ROW_HEADER_EVENT = 'IWEVENT';

    this.ROW_DOT_INDEXES = {
      HEADER: 0,
      SIGN_NORTH: 4,
      VALUE_NORTH: 3,
      SIGN_EAST: 6,
      VALUE_EAST: 5,
      EVENT_ID: 1,
      EVENT_NAME: 2,
      EVENT_LATITUDE: 4,
      EVENT_LONGITUDE: 3
    };
  }

  import() {
    let fileRows = this._fileData.split(this.ROW_SEPARATOR);
    if (fileRows.length < 2) throw new Error('Not enough points in NMEA file to create a track');

    let dots = new Dots();

    fileRows.forEach((row) => {
      // eslint-disable-next-line no-param-reassign
      if (row.length === 0 || typeof row === 'undefined') return;
      row = row.trim().split(',');

      // eslint-disable-next-line default-case
      switch (row[this.ROW_DOT_INDEXES.HEADER]) {
        // eslint-disable-next-line no-case-declarations
        case this.ROW_HEADER_DOT:
          let dot = this.getDot(row);

          if (dot) {
            dots.add(this.getDot(row));
          }
          break;

        case this.ROW_HEADER_EVENT:
          dots.add(this.getEventDot(row));
          break;
      }
    });

    return dots;
  }

  getDot(row) {
    if (typeof row === 'undefined') return;
    let sign;
    let latitude = 0;
    let longitude = 0;

    sign = row[this.ROW_DOT_INDEXES.SIGN_NORTH] === 'N' ? 1 : -1;
    if (row[this.ROW_DOT_INDEXES.VALUE_NORTH].length > 3) {
      // eslint-disable-next-line max-len
      latitude = sign * (parseInt(row[this.ROW_DOT_INDEXES.VALUE_NORTH].substring(0, 2), 10) + (parseFloat((row[this.ROW_DOT_INDEXES.VALUE_NORTH].substring(2))) / 60));
    }

    sign = row[this.ROW_DOT_INDEXES.SIGN_EAST] === 'E' ? 1 : -1;
    if (row[this.ROW_DOT_INDEXES.VALUE_EAST].length > 3) {
      // eslint-disable-next-line max-len
      longitude = sign * (parseInt(row[this.ROW_DOT_INDEXES.VALUE_EAST].substring(0, 3), 10) + (parseFloat((row[this.ROW_DOT_INDEXES.VALUE_EAST].substring(3))) / 60));
    }

    let dot = null;

    if (latitude !== 0 && longitude !== 0) {
      dot = new Dot(latitude, longitude);
    }

    return dot;
  }

  getEventDot(row) {
    if (typeof row === 'undefined') return null;
    let eventName = row[this.ROW_DOT_INDEXES.EVENT_NAME];

    if (eventName.charAt(0) === "'" && eventName.charAt(eventName.length - 1) === "'") eventName = eventName.substr(1, eventName.length - 2);

    let description = '';
    let matches;
    // eslint-disable-next-line camelcase
    let extracted_name;

    // eslint-disable-next-line no-cond-assign
    if ((matches = /.+?(?=: )/.exec(eventName)) !== null && matches.length > 0) {
      // eslint-disable-next-line camelcase
      extracted_name = matches[0];
      description = eventName.slice(extracted_name.length + 1).trim(); // name + ":"
    }

    let eventDefault = row[this.ROW_DOT_INDEXES.EVENT_ID] !== 1;

    // eslint-disable-next-line camelcase
    if (extracted_name) {
      // eslint-disable-next-line camelcase
      eventName = extracted_name;
    }

    if (!eventName && eventDefault) {
      eventName = description;
    }

    // Don't duplicate the name
    if (description === eventName) {
      description = '';
    }

    return new Dot(
      parseFloat(row[this.ROW_DOT_INDEXES.EVENT_LATITUDE]),
      parseFloat(row[this.ROW_DOT_INDEXES.EVENT_LONGITUDE]),
      new Event(
        parseInt(row[this.ROW_DOT_INDEXES.EVENT_ID], 10),
        eventName,
        description,
        '#FFF',
        parseInt(row[this.ROW_DOT_INDEXES.EVENT_ID], 10) !== 1,
        true
      )
    );
  }
}
